import type { Editor } from 'slate';
import { Transforms } from 'slate';

import {
  createDefaultDocElement,
  createDefaultFooters,
  createDefaultHeaders,
  isDocumentElement,
  isFootersElement,
  isHeadersElement,
} from '../../internal';

export function normalizeEditor(editor: Editor): void {
  // Get the first document, headers and footers elements
  const documentIndex = editor.children.findIndex(isDocumentElement);
  const footersIndex = editor.children.findIndex(isFootersElement);
  const headersIndex = editor.children.findIndex(isHeadersElement);

  // Remove all top-level nodes except for the above
  for (let index = editor.children.length - 1; index >= 0; index--) {
    if (![documentIndex, footersIndex, headersIndex].includes(index)) {
      Transforms.removeNodes(editor, { at: [index] });

      const node = editor.children[index];
      console.error('Unexpected top-level node', node);
    }
  }

  // Insert any elements that are missing
  if (documentIndex === -1) Transforms.insertNodes(editor, createDefaultDocElement(), { at: [0] });
  if (footersIndex === -1)
    Transforms.insertNodes(editor, createDefaultFooters(), { at: [editor.children.length] });
  if (headersIndex === -1)
    Transforms.insertNodes(editor, createDefaultHeaders(), { at: [editor.children.length] });
}
